
import Vue from 'vue'
import App from './App'
import router from './router'
import {
  Post,
  Get
} from './config/axiosConfig'

import 'babel-polyfill'
import store from './store'

import echarts from 'echarts'
import './assets/css/index.scss'
import ElementUI from 'element-ui'
// 引入默认的element-ui样式
import 'element-ui/lib/theme-chalk/index.css'
/* eslint-disable no-new */
// 埋点
import uweb from 'vue-uweb'

// 埋点
Vue.use(ElementUI)
Vue.use(uweb, '1275799528')
Vue.config.productionTip = false
Vue.prototype.$post = Post
Vue.prototype.$get = Get
Vue.prototype.$echarts = echarts

/* 定义全局点击函数 */
Vue.prototype.globalClick = function (callback) {
  document.getElementById('app').onclick = function () {
    callback()
  }
}
/* 定义全屏退出函数 */
Vue.prototype.exitFullScreen = function (callback) {
  window.addEventListener('webkitfullscreenchange', function (e) {
    if (!document.webkitIsFullScreen) {
      callback()
    };
  })
}

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  // components: { App },
  // template: '<App/>',
  render: h => h(App)
})


// WEBPACK FOOTER //
// ./src/main.js